/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Start_Page_Share_TitleInputs */

const en_start_page_share_title = /** @type {(inputs: Start_Page_Share_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One link instead of ten messages.`)
};

const pl_start_page_share_title = /** @type {(inputs: Start_Page_Share_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeden link zamiast dziesięciu wiadomości.`)
};

/**
* | output |
* | --- |
* | "One link instead of ten messages." |
*
* @param {Start_Page_Share_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const start_page_share_title = /** @type {((inputs?: Start_Page_Share_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Start_Page_Share_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_start_page_share_title(inputs)
	return en_start_page_share_title(inputs)
});